/**
 * Function to simplify adding tooltips to <el-table-column>
 *
 * Usage: <el-table-column :render-header="withTooltip('Custom tooltip text')"/>
 *
 * @param text
 * @returns {renderHeader}
 */
export default function withTooltip (text) {
  return function renderHeader (h, {column, $index}) {
    return [
      (<help-tooltip title={text} />),
      column.label,
    ]
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/with-tooltip.js